import React, { useState } from "react";
import { formatCPF, formatPhone } from '../utils/formats'
import { faCheck, faCreditCard, faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPix } from "@fortawesome/free-brands-svg-icons";
import { Tooltip, OverlayTrigger, Spinner, Button, Modal } from 'react-bootstrap'
import moment from "moment";
import faSend from './../assets/icons/entrega-rapida.svg'
import faReceived from './../assets/icons/recebido.svg'
import api from "../services/api";
import './componentsCss/SaleCard.css'
import MedicinesIcon from '../assets/img/pilulas.svg';
import Swal from "sweetalert2";

export default function SaleCard({ sale, screen, index, sales, setSales }) {

  const [loading, setLoading] = useState(false)
  const [showMedicinesModal, setShowMedicinesModal] = useState(false)

  const tooltip = (text) => {
    return (
      <Tooltip id="tooltip">
        {text}
      </Tooltip>
    );
  }

  const onChangeStatus = async (value, index) => {
    setLoading(true)

    // console.log('ID', sales[index].id)
    // console.log('NEW VALUE', value)
    // console.log('PH_STATUS', sales[index].ph_status)

    const data = {
      id: sales[index].id,
      status: value
    }

    await api.put('api/attendances/update/pharmacy', JSON.stringify(data))
      .then(response => {
        let updatedSales = [...sales];
        updatedSales[index] = { ...updatedSales[index], ph_status: value }
        setSales(updatedSales)
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false);
      })

    // setTimeout(() => {
    //     let salesPrev = sales
    //     salesPrev[index].status = value
    //     setSales(salesPrev)
    //     setLoading(false)
    // }, 1000);
  }

  const seeMedicines = () => {
    return () => {
      setShowMedicinesModal(true);
    }
  }

  const handleCloseModal = () => {
    setShowMedicinesModal(false);
  }

  const openBudget = () => {
    Swal.fire({
      title: 'Gerando orçamento...',
      text: 'Aguarde um momento.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    api
      .get("api/attendances/" + sale.id + "/prescriptionitems")
      .then((response) => {
        const path = response.data.path;
        window.open(
          "https://codex.inkless.digital/storage/" + path,
          "_blank"
        );
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        Swal.close();
      });
  }

  const statusInfo = () => {
    var value

    switch (sale.ph_status) {
      case 0:
      case null:
        value = {
          text: 'vendido',
          color: 'separation',
          icon: () => {
            if (loading) {
              return (
                <span className="button-icon-action second">
                  <Spinner size="sm" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </span>)
            }
            return (
              <OverlayTrigger placement="auto" overlay={tooltip('Confirmar Pedido')}>
                <span onClick={() => {
                  onChangeStatus(1, index)
                }} className="button-icon-action second">
                  <FontAwesomeIcon icon={faCheck} color="white" />
                </span>
              </OverlayTrigger>)
          }
        }
        break;
      case 1:
        value = {
          text: 'em dispensação',
          color: 'in-separation',
          icon: () => {
            if (loading) {
              return (
                <span className="button-icon-action second">
                  <Spinner size="sm" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </span>)
            }
            return (
              <OverlayTrigger placement="auto" overlay={tooltip('Entregar')}>
                <span onClick={() => {
                  onChangeStatus(2, index)
                }} className="button-icon-action second">
                  <img alt="send" width={25} src={faSend} />
                </span>
              </OverlayTrigger>)
          }
        }
        break;
      case 2:
        value = {
          text: 'entregando',
          color: 'delivering',
          icon: () => {
            if (loading) {
              return (
                <span className="button-icon-action second">
                  <Spinner size="sm" animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </span>)
            }
            return (
              <OverlayTrigger placement="auto" overlay={tooltip('Entregue')}>
                <span onClick={() => {
                  onChangeStatus(3, index)
                }} className="button-icon-action second">
                  <img alt="received" width={25} src={faReceived} />
                </span>
              </OverlayTrigger>)
          }
        }
        break;
      case 3:
        value = {
          text: 'entregue',
          color: 'delivered',
          icon: () => {
            return (
              <></>)
          }
        }
        break;
      case 4:
        value = {
          text: 'cancelado',
          color: 'canceled',
          icon: () => {
            return (
              <></>)
          }
        }
        break;
      default:
        value = {
          text: '',
          color: 'none',
          icon: () => {
            return (<></>)
          }
        }
        break;
    }

    return value
  }

  return (
    <div className="row card-list-col-12 sale-card">
      <div className="col-12 col-sm-6 col-lg-4 col-xl-3 col-item">
        <span style={{ fontWeight: 700 }}>{sale.customer_name}</span>
        <span>{formatCPF(sale.customer_cpf)}</span>
        <span>{formatPhone(sale.customer_mobile)}</span>
        <span>{sale.street}</span>
        <span>
          {sale.city} - {sale.state}
        </span>
        {/* <span>{sale.complement}</span> */}
        <span>{sale.payment_time}</span>
      </div>

      <div className="col-12 col-sm-6 col-lg-4 col-xl-3 col-item">
          <span>{sale.street}</span>
          <span>
            {sale.city} - {sale.state}
          </span>
          <span>{sale.complement}</span>
        </div>

      {/* <div className="col-12 col-sm-2 col-item">
        {sale.payment_type === "PIX" && (
          <span>
            <FontAwesomeIcon
              style={{ marginRight: 5 }}
              icon={faPix}
              color="white"
            />
            {sale.payment_type}
          </span>
        )}

        {sale.payment_type.includes("CRÉDITO") && (
          <span>
            <FontAwesomeIcon
              style={{ marginRight: 5 }}
              icon={faCreditCard}
              color="white"
            />
            {sale.payment_type}
          </span>
        )}

        {sale.payment_type === "DÉBITO" && (
          <span>
            <FontAwesomeIcon
              style={{ marginRight: 5 }}
              icon={faCreditCard}
              color="white"
            />
            {sale.payment_type}
          </span>
        )}
      </div> */}

      <div className="col-12 col-sm-3 col-lg-2 col-xl-1 col-item">
        <span>
          {
            Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(sale?.value_paid)
          }
        </span>
      </div>

      <div className="col-12 col-sm-3 col-lg-2 col-item align-items-center">
        <Button
          variant="outline-primary"
          style={{ color: 'white', borderColor: '#56CAf0' }}
          onClick={seeMedicines(sale.items)}
        >
          <img src={MedicinesIcon} width={25} alt="Ver medicamentos" />
          <span className="ms-2">Ver medicamentos</span>
        </Button>
      </div>

      <div className="col-12 col-sm-3 col-lg-6 col-xl-2 row-item">
        {screen !== "reportbalance" ? (
          <span
            style={{ marginBottom: 10, marginTop: 10 }}
            className={"status-info " + statusInfo(sale).color}
          >
            {statusInfo(sale).text}
          </span>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {sale.date_paid !== null && (
                <>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: "900",
                      opacity: 0.6,
                      paddingTop: 5,
                    }}
                  >
                    data de repasse
                  </span>
                  <span>{moment(sale.date_paid).format("DD/MM/YYYY")}</span>
                </>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {sale.value_paid === null ? (
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: "900",
                    opacity: 0.6,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  não pago
                </span>
              ) : (
                <>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: "900",
                      opacity: 0.6,
                      paddingTop: 5,
                    }}
                  >
                    valor pago
                  </span>
                  <span>
                    R${" "}
                    {sale?.value_paid.toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                  </span>
                </>
              )}
            </div>
          </>
        )}
      </div>

      <div className="col-12 col-sm-3 col-lg-6 col-xl-1 row-item">
        {screen !== "reportsale" &&
          screen !== "reportbalance" &&
          statusInfo(sale).icon()}

        {/* <OverlayTrigger placement="auto" overlay={tooltip("Orçamento")}>
          <span
            onClick={openBudget}
            className="button-icon-action second"
          >
            <FontAwesomeIcon icon={faHandHoldingDollar} color="white" />
          </span>
        </OverlayTrigger> */}
      </div>


      <Modal show={showMedicinesModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Medicamentos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {sale.items && sale.items.length > 0 ? (
              <div className="medicines-list col-11 m-auto">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Quantidade</th>
                      <th>Tipo</th>
                      <th>Unidade</th>
                      <th style={{ textAlign: 'right' }}>Preço Unitário</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sale.items.map((item, i) => (
                      <tr key={i}>
                        <td>{item.name}</td>
                        <td className="text-center">{item.quantity}</td>
                        <td>{item.type}</td>
                        <td>{item.unit}</td>
                        <td style={{ textAlign: 'right' }}>
                          R$ {Number(item.unit_price)?.toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr>                  
                      <td colSpan="5" className="text-end fw-bold">
                        Total: 
                        R$ {sale.items.reduce((sum, item) => sum + (item.quantity * item.unit_price), 0)?.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            ) : (
              <div className="text-center p-4">
                <p>Nenhum medicamento encontrado para esta venda.</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
    </div>
  );
}